<template>
  <article :class="getClass()" :id="'tease-' + item.id">
    <div :class="getImageClass()" v-if="itemStore.showImage">
      <img
        v-if="item.image.large"
        :src="item.image.large"
        :alt="item.image.alt"
      />
    </div>
    <h4 class="post-title">{{ item.title }}</h4>
    <p v-if="'title' in item.data" class="contact-jobtitle">
      {{ item.data["title"] }}
    </p>
    <a v-if="'phone' in item.data" class="contact-phone">{{
      item.data["phone"]
    }}</a>
    <p v-if="'email' in item.data && item.data['email'].split('@').length > 1">
      <a :href="'mailto:' + item.data['email']">
        {{ item.data["email"].split("@")[0] }}<wbr />@{{
          item.data["email"].split("@")[1]
        }}
      </a>
    </p>
  </article>
</template>

<script setup lang="ts">
import { useItemStore } from "@/itemStore";
import type { Item } from "@/itemStore";

const itemStore = useItemStore();

const props = defineProps<{
  item: Item;
  nr: number;
}>();

const showDate = (date: string) => {
  const d = new Date(date);
  return d.toLocaleDateString(itemStore.lang);
};

const getClass = () => {
  let className = "tease";
  className += " tease-" + itemStore.type;
  props.item.primary.forEach((term) => {
    className += " tease-term-" + term.slug;
  });
  className += " tease-nr-" + props.nr;
  return className;
};

const getTerms = () => {
  let terms: string[];
  terms = [];
  props.item.primary.forEach((term) => {
    terms.push(term.name);
  });
  return terms.join(", ");
};

const getImageClass = () => {
  let className = "image-container";
  if (itemStore.imagePostcard) {
    className += " postcard";
  }
  if (props.item.image.medium) {
    className += " has-image";
  } else {
    className += " placeholder";
  }
  return className;
};
</script>
